import { Languages } from '@wicadu/langscope'

import manager from '@utils/loadLangScopeManager'

function getPathnameLang(pathname?: string): string | null {
  if (!pathname)
    return null

  const [, lang] = pathname.split('/')

  return lang || null
}

export function resolveCurrentLang(
  pageContextLang?: string,
  pathname?: string
): Languages {
  const maybeLang = pageContextLang || getPathnameLang(pathname)

  if (maybeLang && manager.isValidLang(maybeLang as Languages))
    return maybeLang as Languages

  return Languages.English
}
